export default __webpack_public_path__ + "static/media/benefit-1@3x.3024f438.png";